<template>
    <div class="driver-add-supplier-btn-group">
        <el-button type="primary" :loading="passLoading" @click="handleApprove">通过</el-button>
        <el-button type="primary" @click="handleReject">驳回</el-button>
        <DriverApplyDialog ref="daRef" :checkedData="checkedData" @submit="refresh" />
        <RejectDialog ref="rRef" :checkedData="checkedData" @submit="refresh" />
    </div>
</template>
<script>
import { checkPass } from '../../../../api/driverAddSupplier.js'
import DriverApplyDialog from './DriverApplyDialog.vue'
import RejectDialog from './RejectDialog.vue'

const TYPE_MSG = {
    '00': '请检查供应商所属分公司是否维护，并检查司机车辆审批人配置是否配置对应分公司审批人。以上条件满足， 才可执行通过。',
    '0': '加入同个供应商的申请才可执行批量通过。',
    '1': '供应商已绑定以下司机，请驳回司机申请。',
}

export default {
    components: { DriverApplyDialog, RejectDialog },
    props: {
        checkedData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            passLoading: false,
        }
    },
    methods: {
        handleApprove() {
            if (!this.selectValid()) {
                return false
            }
            this.passLoading = true
            const applyCodeList = this.checkedData.map(item => item.applyCode)
            checkPass({ applyCodeList }).then(res => {
                if (res && +res.code === 0) {
                    if (res.data && res.data.checkCode) {
                        this.showTips(res.data.checkCode, res.data.checkContent)
                    } else {
                        this.$refs.daRef.open()
                    }
                }
            }).finally(() => { this.passLoading = false })
        },
        showTips(type, content) {
            this.$alert(`<div class="driver-add-supplier-fist-tip">${TYPE_MSG[type]}</div><div>${content ? '司机：' + content : ''}</div>`, '提示', {
                customClass: 'driver-add-supplier-tip-content',
                dangerouslyUseHTMLString: true
            })
        },
        handleReject() {
            if (!this.selectValid()) {
                return false
            }
            this.$refs.rRef.open()
        },
        selectValid() {
            let flag = true
            if (!this.checkedData.length) {
                this.$message.warning('请先选择数据')
                flag = false
            } else if (this.checkedData.length > 10) {
                this.$message.warning('最多支持复选10条数据')
                flag = false
            }
            return flag
        },
        refresh() {
            this.$emit('fresh')
        }
    }
}
</script>
<stype lang="less">
    .driver-add-supplier-tip-content {
        .driver-add-supplier-fist-tip {
            padding-bottom: 15px;
        }
    }
</stype>